<template>
  <div>
    <div>
      <a-modal
        ref="modal"
        title="Create a New Role"
        :footer="null"
        v-model="visible"
        okText="Create"
        @cancel="onCancel"
      >
        <a-row>
          <roles-form :role="role"></roles-form>
        </a-row>
      </a-modal>
    </div>
  </div>
</template>

<script>
import { setTimeout } from "timers";
import RolesForm from "@/components/Cards/Forms/Roles";
export default {
  data() {
    return {
      visible: true,
      form: this.$form.createForm(this, { name: "coordinated" }),
      role: {
        name: "",
        description: "",
        active: ""
      }
    };
  },
  components: { RolesForm },
  methods: {
    showModal() {
      this.visible = true;
    },
    onCancel(e) {
      return this.$router.push({ name: "roles" });
    }
  },
  mounted() {}
};
</script>
